var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({staticClass:"btn",on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},'button',_vm.$attrs,false),[(_vm.hasIcon)?[_c('span',[_vm._t("default")],2)]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }